import { API_TYPE } from '@umu/umu-fetch';
const BasePath = '/uapi/v1';
const GuidePath = '/uapi/v1/guide';

export const GuideAPI = {
    /**
     * 引导状态
     */
    GUIDE_GET_STEP_STATUS: {
        url: `${GuidePath}/status`,
        type: API_TYPE.GET,
    },
    /**
     * 设置引导状态
     */
    GUIDE_POST_STEP_STATUS: {
        url: `${GuidePath}/upd-status`,
        type: API_TYPE.POST,
    },
    /**
     * 企业功能模块是否开通
     */
    GUIDE_MODULE_PERMISSION: {
        url: `${BasePath}/enterprise/module-permission`,
        type: API_TYPE.GET,
    },
};
